import React, { Component } from 'react';
import { Button, Icon, Pagination } from 'semantic-ui-react';
import './styles.scss';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import EmployeeForm from '../../components/EmployeeForm';
import { exportFileAction } from '../../core/actions/commonAction';
import {
    getEmployeeList, addEmployeeAction,
    updateEmployeeAction, deleteEmployeeAction
} from '../../core/actions/employeeAction';
import { getPositionList } from '../../core/actions/positionAction';
import { getDepartmentList } from '../../core/actions/departmentAction';
import ProjectTable from '../../components/ProjectTable';
import CONSTANT from '../../core/constant/constant';
import functionCommon from "../../core/common/function";
import BackToTop from '../../components/BackToTop';
import moment from 'moment';
class EmployeePage extends Component {

    constructor() {
        super()
        this.state = {
            paramList: {
                isSearch: 1,
                employeeCode: '',
                nickName: '',
                firstName: '',
                lastName: '',
                email: '',
                role: '',
                billable: '',
                status: 0,
                startingDate: "",
                officialDate: "",
                resignDate: "",
                isOMSite: 0,
                'employeePosition[]': '',
                currentPage: 1,
                pageRecord: CONSTANT.pageRecord,
                sortBy: 'employeeCode-ASC',
                level: ''
            },
            paramPositionList: {
                isSearch: 0,
                positionCode: '',
                positionName: '',
                currentPage: 0,
                pageRecord: CONSTANT.pageRecord,
                sortBy: 'positionCode-ASC'
            },
            paramDepartmentList: {
                isSearch: 0,
                departmentCode: '',
                departmentName: '',
                currentPage: 0,
                pageRecord: CONSTANT.pageRecord,
                sortBy: 'departmentCode-ASC'
            },
            tableStructure: [
                {
                    label: 'labels.id',
                    type: 'id',
                    isClass: 'example-class'
                },
                {
                    label: 'labels.employeeCode',
                    type: 'employeeCode',
                    sort: true
                },
                {
                    label: 'labels.nickName',
                    type: 'nickName'
                },
                {
                    label: 'labels.firstName',
                    type: 'firstName'
                },
                {
                    label: 'labels.lastName',
                    type: 'lastName'
                },
                {
                    label: 'labels.position',
                    type: 'positionName',
                    subType: 'employeePosition',
                    isValueInArray: true,
                    sort: true
                },
                {
                    label: 'labels.department',
                    type: 'departmentName',
                    subType: 'employeePosition',
                    isValueInArray: true,
                    sort: true
                },
                {
                    label: 'labels.billable',
                    type: 'billable',
                    isCheckbox: true
                },
                {
                    label: 'labels.status',
                    type: 'status',
                    isChangeText: true,
                    arrayTextChange: {
                        '0': 'labels.working',
                        '1': 'labels.nonWorking'
                    }

                },
                {
                    label: 'labels.startingDate',
                    type: 'startingDate'
                },
                {
                    label: 'labels.officialDate',
                    type: 'officialDate'
                },
                {
                    label: 'labels.resignDate',
                    type: 'resignDate'
                },
                {
                    label: 'labels.omSite',
                    type: 'isOMSite',
                    isCheckbox: true
                },
            ],
            employee: {
                id: 1,
                employeeCode: '',
                nickName: '',
                firstName: '',
                lastName: '',
                email: '',
                role: '',
                billable: '',
                status: 0,
                startingDate: "",
                officialDate: "",
                resignDate: "",
                isOMSite: 0,
                employeePosition: [
                    {
                        positionId: '',
                        positionCode: '',
                        positionName: '',
                        departmentId: '',
                        departmentCode: '',
                        departmentName: '',
                        isMain: '1'
                    }
                ],
                level: ''
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            data: '',
            totalPage: 0,
            activePage: 1,
            disabled: true,
            btnDisable: false,
            unSelectRow: false,
            exportDisabled: false,
            errorCode: '',
            successCode: '',
            isSearch: 1,
            totalRecord: '',
            rowId: '',
            isAdded: false,
            isDisableOfficialDate: false
        }      
        this.officialDateRef = React.createRef(null);
    }

    componentWillMount() {
        this.props.getEmployeeList(this.state.paramList);
        this.props.getPositionList(this.state.paramPositionList);
        this.props.getDepartmentList(this.state.paramDepartmentList);
    }

    componentWillReceiveProps(nextProps) {
        const nextPropsEmployee = nextProps.employeeReducer;
        if (nextProps.employeeReducer.isLoading) {
            this.clearEmployee();
            if (this.state.isAdded === true) {
                this.getList();
            } else {
                this.props.getEmployeeList(this.state.paramList);
            }
        } else {            
            const data = nextPropsEmployee.dataEmployee ? nextPropsEmployee.dataEmployee.employeeList : [];
            this.setState({
                data: data,
                totalPage: nextPropsEmployee.dataEmployee ? nextPropsEmployee.dataEmployee.totalPage : 1,
                totalRecord: nextPropsEmployee.dataEmployee ? nextPropsEmployee.dataEmployee.totalRecord : 0,
                activePage: nextPropsEmployee.dataEmployee ? nextPropsEmployee.dataEmployee.currentPage : 1,
                btnDisable: false
            });

            // No data
            if (!data || data && !data[0]) {
                this.setState({
                    errorCode: '018',
                    exportDisabled: true
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: '' });
                    }
                        .bind(this),
                    2000
                );
            } else {
                this.setState({
                    exportDisabled: false,
                    errorCode: ''
                });
            }

            if (nextProps.employeeReducer.successCode) {
                this.setState({
                    successCode: nextProps.employeeReducer.successCode,
                });
                if (this.state.isAdded === true) {
                    this.clearParamList(false);
                }
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.employeeReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }

            if (nextProps.employeeReducer.errorCode) {
                
                this.setState({
                    errorCode: nextProps.employeeReducer.errorCode,
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.employeeReducer.errorCode = "";
                    }.bind(this),
                    2000
                );
            }
        }
    }

    async getList() {
        let clrParam = await this.clearParamList(false);
        return this.props.getEmployeeList(this.state.paramList);       
    }

    // Search Employee
    async searchEmployeeAction() {
        this.clearError();
        this.setState({ btnDisable: true });
        const emPosData = this.state.employee.employeePosition.map(item =>
            (item.departmentId)
                ? item.positionId + '-' + item.departmentId
                : item.positionId
        );
        const searchParam = {
            isSearch: 1,
            employeeCode: this.state.employee.employeeCode,
            nickName: this.state.employee.nickName,
            firstName: this.state.employee.firstName,
            lastName: this.state.employee.lastName,
            email: this.state.employee.email,
            role: this.state.employee.role,
            billable: this.state.employee.billable,
            status: this.state.employee.status,
            startingDate: this.state.employee.startingDate,
            officialDate: this.state.employee.officialDate,
            resignDate: this.state.employee.resignDate,
            isOMSite: this.state.employee.isOMSite,
            'employeePosition[]': emPosData.join(','),
            currentPage: 1,
            pageRecord: CONSTANT.pageRecord,
            sortBy: this.state.paramList.sortBy,
            level: this.state.employee.level
        };

        await this.setState({
            paramList: searchParam,
            activePage: 1,
            isSearch: 1,
            disabled: true,
            unSelectRow: false
        })

        return this.props.getEmployeeList(searchParam);
    }

    // Add Employee
    addEmployee = () => {
        if (!this.checkValidate()) return;        
        this.setState({btnDisable: true});
        const emPosData = this.state.employee.employeePosition.map(item =>
            (item.departmentId)
                ? item.positionId + '-' + item.departmentId + '-' + item.isMain
                : item.positionId
        );
        const addParams = {
            employeeCode: this.state.employee.employeeCode,
            nickName: this.state.employee.nickName,
            firstName: this.state.employee.firstName,
            lastName: this.state.employee.lastName,
            email: this.state.employee.email,
            role: this.state.employee.role,
            billable: this.state.employee.billable,
            status: this.state.employee.status,
            startingDate: this.state.employee.startingDate,
            officialDate: this.state.employee.officialDate,
            resignDate: this.state.employee.resignDate,
            isOMSite: this.state.employee.isOMSite,
            password: '',
            'employeePosition[]': emPosData.join(','),
            level: this.state.employee.level
        }
        this.setState({isAdded: true});
        return this.props.addEmployeeAction(addParams);
    }

    // Update Employee
    updateEmployeeAction = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true});
        const emPosData = this.state.employee.employeePosition.map(item =>
            (item.departmentId)
                ? item.positionId + '-' + item.departmentId + '-' + item.isMain
                : item.positionId
        );
        const updateParams = {
            id: this.state.employee.id,
            employeeCode: this.state.employee.employeeCode,
            nickName: this.state.employee.nickName,
            firstName: this.state.employee.firstName,
            lastName: this.state.employee.lastName,
            email: this.state.employee.email,
            role: this.state.employee.role,
            billable: this.state.employee.billable,
            status: this.state.employee.status,
            startingDate: this.state.employee.startingDate,
            officialDate:
                this.state.employee.officialDate === this.officialDateRef ? null : this.state.employee.officialDate,
            resignDate: this.state.employee.resignDate,
            isOMSite: this.state.employee.isOMSite,
            password: '',
            'employeePosition[]': emPosData.join(','),
            level: this.state.employee.level
        }        
        this.setState({isAdded: false});
        return this.props.updateEmployeeAction(updateParams);
    }

    // Delete Employee
    deleteEmployee = () => {
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        this.clearEmployee();
        if (this.state.data.length === 1) {
            this.setState(prevState => ({
                paramList: {
                    ...prevState.paramList,
                    currentPage: 1
                }
            }));
        }
        this.setState({isAdded: false});
        return this.props.deleteEmployeeAction({ id: id });
    }

    // Export Employee
    employeeExportAction = () => {
        this.clearError();
        const exportParam = {
            billable: this.state.paramList.billable || '',
            role: this.state.paramList.role || '',
            email: this.state.paramList.email || '',
            nickName: this.state.paramList.nickName || '',
            firstName: this.state.paramList.firstName || '',
            lastName: this.state.paramList.lastName || '',
            employeeCode: this.state.paramList.employeeCode || '',
            'employeePosition[]': this.state.paramList['employeePosition[]'],
            status: this.state.paramList.status || 0,
            sortBy: this.state.paramList.sortBy
        };
        this.props.exportFileAction({
            'urlGetkey': 'employee/requestSecretKey',
            'urlDownfile': 'employee/employeeExport'
        }, exportParam)
    }

    // Clear Employee
    clearEmployee = () => {
        this.setState({
            employee: {
                id: 1,
                employeeCode: '',
                nickName: '',
                firstName: '',
                lastName: '',
                email: '',
                role: '',
                billable: '',
                status: 0,
                startingDate: "",
                officialDate: "",
                resignDate: "",
                isOMSite: 0,
                employeePosition: [
                    {
                        positionId: '',
                        positionCode: '',
                        positionName: '',
                        departmentId: '',
                        departmentCode: '',
                        departmentName: '',
                        isMain: '1'
                    }
                ],
                level: ''
            },
            disabled: true,
            unSelectRow: false,
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            isDisableOfficialDate: false
        })
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }
    
    // Clear param list call API
    clearParamList = (isSort) => {
        this.setState({
            paramList: {
                isSearch: 1,
                employeeCode: '',
                nickName: '',
                firstName: '',
                lastName: '',
                email: '',
                role: '',
                billable: '',
                status: 0,
                startingDate: "",
                officialDate: "",
                resignDate: "",
                isOMSite: 0,
                'employeePosition[]': '',
                currentPage: 1,
                pageRecord: CONSTANT.pageRecord,
                sortBy: (isSort !== true) ? "employeeCode-ASC" : this.state.paramList.sortBy,
                level: ''
            },
        });
    }

    // Handle On Change Employee
    changeEmployee = (inputHtml) => {
        let isPosition = inputHtml.target.name.indexOf("positionCode");
        let isDepartment = inputHtml.target.name.indexOf("departmentName");
        let isMain = inputHtml.target.name.indexOf("isMain");

        let name = inputHtml.target.name;
        let value = inputHtml.target.value;
        
        if (isMain !== -1) {
            this.changePosition(inputHtml);
        } else {
            this.setState(prevState => ({
                employee: {
                    ...prevState.employee,
                    [name]: value
                },
            }));
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {
                        ...prevState.inputSubmit.formError,
                        [name]: ''
                    }
                }
            }));
        }
    }

    // Handle On Change Employee StartingDate + OfficalDate + CheckBox
    changeDateCheckbox = (value, name) => {
        this.setState((prevState) => ({
            employee: {
                ...prevState.employee,
                [name]: value,
            },
        }));
        this.setState((prevState) => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: "",
                },
            },
        }));
    };
    
    // Hande On Change AutoComplete
    changeAutoComplete = (evt) => {
        const isPosition = evt._name.indexOf("positionCode");
        const isDepartment = evt._name.indexOf("departmentName");
        const indexPosition = evt._name.slice(evt._name.indexOf("-") + 1, evt._name.length);
        const name = evt._name;
        const value = evt._value;

        if (isPosition !== -1) {
            this.setState(prevState => ({
                employee: {
                    ...prevState.employee,
                    employeePosition: prevState.employee.employeePosition.map(
                        (employeePosition, i) => i == indexPosition
                            ? (
                                { ...employeePosition, positionId: value }
                            ) : employeePosition
                    )
                },
            }));
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {
                        ...prevState.inputSubmit.formError,
                        [name]: ''
                    }
                }
            }));
        }

        if (isDepartment !== -1) {
            this.setState(prevState => ({
                employee: {
                    ...prevState.employee,
                    employeePosition: prevState.employee.employeePosition.map(
                        (employeePosition, i) => i == indexPosition
                            ? (
                                { ...employeePosition, departmentId: value }
                            ) : employeePosition
                    )
                },
            }));
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {
                        ...prevState.inputSubmit.formError,
                        [name]: ''
                    }
                }
            }));
        }
    }

    // Handle On Change Position
    changePosition = (evt) => {
        const name = evt.target.name;
        const indexPosition = evt.target.name.slice(evt.target.name.indexOf("-") + 1, evt.target.name.length);
        const isMain = evt.target.name.indexOf("isMain");

        if (isMain !== -1) {
            this.setState(prevState => ({
                employee: {
                    ...prevState.employee,
                    employeePosition: prevState.employee.employeePosition.map(
                        (employeePosition, i) => i == indexPosition
                            ? (
                                { ...employeePosition, isMain: '1' }
                            ) : { ...employeePosition, isMain: '0' }
                    )
                },
            }));
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {
                        ...prevState.inputSubmit.formError,
                        [name]: ''
                    }
                }
            }));
        }
    }

    // Select Employee on Click
    onRowClick = (val) => {
        this.clearError();
        this.officialDateRef = moment(val.officialDate).format("DD-MM-YYYY");
        let employee = {
            id: (val.id !== null) ? val.id : '',
            employeeCode: (val.employeeCode !== null) ? val.employeeCode : '',
            nickName: (val.nickName !== null) ? val.nickName : '',
            firstName: (val.firstName !== null) ? val.firstName : '',
            lastName: (val.lastName !== null) ? val.lastName : '',
            email: (val.email !== null) ? val.email : '',
            role: (val.role !== null) ? val.role : '',
            billable: (val.billable !== null) ? val.billable : '',
            status: (val.status !== null) ? val.status : '',
            startingDate: (val.startingDate !== null) ? moment(val.startingDate).format("DD-MM-YYYY") : '',
            officialDate: (val.officialDate !== null) ? moment(val.officialDate).format("DD-MM-YYYY") : '',
            resignDate: (val.resignDate !== null) ? moment(val.resignDate).format("DD-MM-YYYY") : '',
            isOMSite: (val.isOMSite !== null) ? val.isOMSite : '',
            employeePosition: val.employeePosition,
            level: (val.level !== null) ? val.level : '',
        }

        this.setState({
            disabled: false,
            employee: employee,
            unSelectRow: true,
            rowId: val.id,
            isDisableOfficialDate:
                val.officialDate !== "" && (moment(moment()).isSameOrAfter(moment(val.officialDate))),
        });
    }

    // SortBy Employee
    sortBy = async (val) => {
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                sortBy: val
            }
        }));

        return this.props.getEmployeeList(this.state.paramList);
    }

    // Pagination
    async handlePaginationChange(val) {
        await this.setState({
            activePage: val,
            paramList: {
                isSearch: this.state.isSearch,
                employeeCode: this.state.paramList.employeeCode,
                nickName: this.state.paramList.nickName,
                firstName: this.state.paramList.firstName,
                lastName: this.state.paramList.lastName,
                email: this.state.paramList.email,
                role: this.state.paramList.role,
                billable: this.state.paramList.billable,
                status: this.state.paramList.status,
                startingDate: this.state.employee.startingDate,
                officialDate: this.state.employee.officialDate,
                resignDate: this.state.employee.resignDate,
                isOMSite: this.state.employee.isOMSite,
                'employeePosition[]': this.state.paramList['employeePosition[]'],
                currentPage: val,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy,
                level: this.state.paramList.level
            }
        });

        return this.props.getEmployeeList(this.state.paramList);
    }

    handleAddOrRemove = (data) => {
        if (data.value === 'add') {
            if (this.state.employee.employeePosition.length < 5) {
                this.setState(prevState => ({
                    employee: {
                        ...prevState.employee,
                        employeePosition: prevState.employee.employeePosition.concat(
                            {
                                positionId: '',
                                positionCode: '',
                                positionName: '',
                                departmentId: '',
                                departmentCode: '',
                                departmentName: '',
                                isMain: '0'
                            }
                        )
                    }
                }));
            }
        } else {
            let _employeePosition = this.state.employee.employeePosition.filter((item, i) => i !== data.idx);            
            this.setState(prevState => ({
                employee: {
                    ...prevState.employee,
                    employeePosition: _employeePosition
                }
            }));
            
            if (!this.isKeyInObject(_employeePosition, '1')) {
                this.setState(prevState => ({
                    employee: {
                        ...prevState.employee,
                        employeePosition: prevState.employee.employeePosition.map(
                            (employeePosition, i) => i == 0 
                            ? (
                                { ...employeePosition, isMain: '1' }
                            ) : { ...employeePosition, isMain: '0' }
                        )
                    },
                }));
            }
        }
    }

    isKeyInObject = (arr, value) => {
        return arr.some(function(el) {
            return el.isMain === value;
        }); 
    }

    isPositionObject = (arr) => {
        return arr.some(function(el) {
            return el.positionId === '';
        }); 
    }

    isDepartmentObject = (arr) => {
        return arr.some(function(el) {
            return el.departmentId == '';
        }); 
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};
        const invalidDate =
            this.state.employee.officialDate !== "" &&
            moment(moment(this.state.employee.officialDate, "DD-MM-YYYY")).isBefore(
                moment(this.state.employee.startingDate, "DD-MM-YYYY")
            );
        const invalidResignDateStaring = this.state.employee.startingDate !== "" &&
        moment(moment(this.state.employee.resignDate, "DD-MM-YYYY")).isBefore(
            moment(this.state.employee.startingDate, "DD-MM-YYYY")
        );
        const invalidResignDateOfficial = this.state.employee.officialDate !== "" &&
        moment(moment(this.state.employee.resignDate, "DD-MM-YYYY")).isBefore(
            moment(this.state.employee.officialDate, "DD-MM-YYYY")
        );

        (this.state.employee.employeeCode.trim() === '') ? _formError['employeeCode'] = 'message.100' : _formError['employeeCode'] = '';
        (this.state.employee.firstName.trim() === '') ? _formError['firstName'] = 'message.101' : _formError['firstName'] = '';
        (this.state.employee.role === '') ? _formError['role'] = 'message.102' : _formError['role'] = '';
        (this.state.employee.billable === '') ? _formError['billable'] = 'message.103' : _formError['billable'] = '';
        (this.state.employee.status === '') ? _formError['status'] = 'message.104' : _formError['status'] = '';
        (this.state.employee.level === '') ? _formError['level'] = 'message.107' : _formError['level'] = '';
        _formError["startingDate"] = this.state.employee.startingDate === "" ? "message.029" : "";
        _formError["officialDate"] = invalidDate ? "message.045" : "";
        _formError["resignDateWithStarting"] = invalidResignDateStaring ? "message.048" : "";
        _formError["resignDateWithOfficial"] = invalidResignDateOfficial ? "message.049" : "";
        this.state.employee.employeePosition.map((item, i) => {
            (item.positionId === '') ? _formError['positionCode-' + i] = 'message.106' : _formError['positionCode-' + i] = '';
            (item.departmentId === '') ? _formError['departmentName-' + i] = 'message.105' : _formError['departmentName-' + i] = '';
        })

        // if (this.state.employee.email === '') {
        //     _formError['email'] = 'message.002'
        // } else if (!functionCommon.validateEmail(this.state.employee.email)) {
        //     _formError['email'] = 'message.020'
        // } else {
        //    _formError['email'] = '';
        // }
        
        if (this.state.employee.employeeCode.trim() !== ''
            && this.state.employee.firstName.trim() !== ''
            // && this.state.employee.email !== ''
            // && functionCommon.validateEmail(this.state.employee.email)
            && this.state.employee.role !== ''
            && this.state.employee.billable !== ''
            && this.state.employee.status !== ''
            && this.state.employee.level !== ''
            && this.state.employee.startingDate !== ''
            && !invalidDate
            && !invalidResignDateStaring
            && !invalidResignDateOfficial
            && !this.isPositionObject(this.state.employee.employeePosition)
            && !this.isDepartmentObject(this.state.employee.employeePosition)) {
                isValidate = true;
                this.setState(prevState => ({
                    inputSubmit: {
                        ...prevState.inputSubmit,
                        formError: {}
                    }
                }));   
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }
            
        return isValidate;
    }

    render() {
        const { t } = this.props;
        const { activePage, errorCode, successCode, btnDisabled } = this.state;

        return (
            <div className="employee-wrap">
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = '/employee' }, 500)}>{t("navigation.master")}</span>
                    / <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>{t("navigation.employee")}</span></h2>
                <div className="list-actions">
                    <Button primary onClick={() => this.searchEmployeeAction()} disabled={this.state.btnDisable}><Icon name='search' />{t('button.search')}</Button>
                    <Button primary onClick={() => this.addEmployee()} disabled={this.state.btnDisable}><Icon name='add circle' />{t('button.add')}</Button>
                    <Button onClick={(e) => this.updateEmployeeAction()} primary disabled={this.state.disabled} className="update-btn"><Icon name='edit' />{t('button.update')}</Button>
                    <Button onClick={(e) => this.deleteEmployee()} primary disabled={this.state.disabled} className="delete-btn"><Icon name='trash alternate outline' />{t('button.delete')}</Button>
                    <Button onClick={(e) => this.employeeExportAction()} disabled={this.state.exportDisabled}><Icon name='file excel outline' />{t('button.export')}</Button>
                    <Button onClick={(e) => this.clearEmployee()}><Icon name='refresh' />{t('button.clearAll')}</Button>
                </div>
                <EmployeeForm
                    employeeData={this.state.employee}
                    dataPosition={this.props.positionReducer.dataPosition.positionList}
                    dataDepartment={this.props.departmentReducer.dataDepartment.departmentList}
                    changeEmpoyee={(input) => this.changeEmployee(input)}
                    handleAddOrRemove={(input) => this.handleAddOrRemove(input)}
                    changeAutoComplete={(input) => this.changeAutoComplete(input)}
                    changeDateCheckboxEmployee={this.changeDateCheckbox}
                    isDisableOfficialDate={this.state.isDisableOfficialDate}
                    isError={this.state.inputSubmit.formError}
                />
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {(errorCode == "010") ? t("message.019") : t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    onRowClick={(val) => this.onRowClick(val)}
                    defaultSort={this.state.paramList.sortBy}
                    sortBy={(val) => this.sortBy(val)}
                    unSelectRow={this.state.unSelectRow}
                />
                <div className="table-paging">
                    {(this.state.data && this.state.data[0]) ?
                        <Pagination
                            size='tiny'
                            activePage={activePage}
                            firstItem={null}
                            lastItem={null}
                            totalPages={this.state.totalPage}
                            prevItem={{
                                disabled: this.state.activePage == 1,
                                content: <Icon name='chevron left' />,
                                icon: true
                            }}
                            nextItem={{
                                disabled: this.state.activePage == this.state.totalPage,
                                content: <Icon name='chevron right' />,
                                icon: true
                            }}
                            onPageChange={(e, { activePage }) => this.handlePaginationChange(activePage)} /> : ''}
                </div>
                <BackToTop />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
})

const mapDispatchToProps = dispatch => ({
    getEmployeeList: (opt) => dispatch(getEmployeeList(opt)),
    getPositionList: (opt) => dispatch(getPositionList(opt)),
    getDepartmentList: (opt) => dispatch(getDepartmentList(opt)),
    addEmployeeAction: (opt) => dispatch(addEmployeeAction(opt)),
    updateEmployeeAction: (opt) => dispatch(updateEmployeeAction(opt)),
    deleteEmployeeAction: (opt) => dispatch(deleteEmployeeAction(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param))
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(EmployeePage);
